import { useEffect } from "react";

import { useSessionStorage } from "usehooks-ts";
import { useUser } from "../Auth/UnifiedAuthProvider";

import { useAnalytics } from "./AnalyticsProvider";

export function UserIdentifier() {
  const { trackEvent, identify } = useAnalytics();
  const { user } = useUser();
  const [hasLoggedInThisSession, setHasLoggedInThisSession] = useSessionStorage(
    "hasLoggedInThisSession",
    false,
  );
  const [signUpTracked, setSignUpTracked] = useSessionStorage(
    "signUpTracked",
    false,
  );

  const [, setHadSession] = useSessionStorage("hadSession", false);

  useEffect(() => {
    if (user && !hasLoggedInThisSession) {
      sessionStorage.removeItem("currentBotSession");
      sessionStorage.removeItem("hasLoggedInThisSession");
      const userId = user.id;
      const userProperties = {
        email: user.email,
        name:
          user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : (user.firstName ?? user.email),
      };

      identify(userId, userProperties);

      if (!signUpTracked) {
        trackEvent("signed_up", userProperties);
        setSignUpTracked(true);
      }

      trackEvent("logged_in", userProperties);

      setHasLoggedInThisSession(true);
      setHadSession(true);
    }
  }, [
    hasLoggedInThisSession,
    identify,
    setHadSession,
    setHasLoggedInThisSession,
    signUpTracked,
    setSignUpTracked,
    trackEvent,
    user,
  ]);

  return null;
}
